// mapper for synchronization BE locales and date-fns format dates
// for more details https://gist.github.com/typpo/b2b828a35e683b9bf8db91b5404f1bd1
export enum DateFnsLocaleMapper {
  'ar-SA' = 'arSA',
  'bn-BD' = 'bn',
  'bn-IN' = 'bn',
  'cs-CZ' = 'cs',
  'da-DK' = 'da',
  'de-AT' = 'de-AT',
  'de-CH' = 'de',
  'de-DE' = 'de',
  'el-GR' = 'el',
  'en-AU' = 'en-AU',
  'en-CA' = 'en-CA',
  'en-GB' = 'en-GB',
  'en-IE' = 'en-IE',
  'en-IN' = 'en-IN',
  'en-NZ' = 'en-NZ',
  'en-US' = 'en-US',
  'en-ZA' = 'en-ZA',
  'es-AR' = 'es',
  'es-CL' = 'es',
  'es-CO' = 'es',
  'es-ES' = 'es',
  'es-MX' = 'es',
  'es-US' = 'es',
  'fi-FI' = 'fi',
  'fr-BE' = 'fr',
  'fr-CA' = 'fr-CA',
  'fr-CH' = 'fr-CH',
  'fr-FR' = 'fr',
  'he-IL' = 'he',
  'hi-IN' = 'hi',
  'hu-HU' = 'hu',
  'id-ID' = 'id',
  'it-CH' = 'it',
  'it-IT' = 'it',
  'ja-JP' = 'ja',
  'ko-KR' = 'ko',
  'nl-BE' = 'nl-BE',
  'nl-NL' = 'nl',
  'no-NO' = 'nb',
  'pl-PL' = 'pl',
  'pt-BR' = 'pt-BR',
  'pt-PT' = 'pt',
  'ro-RO' = 'ro',
  'ru-RU' = 'ru',
  'sk-SK' = 'sk',
  'sv-SE' = 'sv',
  'ta-IN' = 'ta',
  'ta-LK' = 'ta',
  'th-TH' = 'th',
  'tr-TR' = 'tr',
  'zh-CN' = 'zh-CN',
  'zh-HK' = 'zh-HK',
  'zh-TW' = 'zh-TW',
}
